// client/marks/bold.ts
import "@adornis/chemistry/elements/components/x-icon.js";
import { BOLD_KEY, BOLD_SCHEMA } from "../../schema/marks/bold.js";
import { toggleMark } from "../helper/toggleMark.js";
import { MenuItemGroup } from "../types.js";
import { isInText } from "../util.js";
var bold = () => ({
  mark: {
    name: BOLD_KEY,
    schema: BOLD_SCHEMA()
  },
  menuItems: [
    {
      group: MenuItemGroup.TEXT_STYLE,
      label: "Fett",
      icon: "format_bold",
      run: (editorView) => {
        toggleMark({ markName: bold().mark.name, view: editorView, attrs: {} })(editorView.state, editorView.dispatch);
      },
      isActive: (editorView) => {
        return toggleMark({
          markName: bold().mark.name,
          view: editorView,
          attrs: {}
        })(editorView.state);
      },
      shouldVisualize: (view) => {
        return isInText(view.state);
      }
    }
  ]
});
export {
  bold
};
